import store from '../../spa_registration_app/store';
import router from '../../spa_registration_app/router';
import { i18n } from '../../src/plugins/i18n';

export default {
  store,
  router,
  i18n,
};
